const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}'

const TRAILING_IDENTIFIER_PATTERN = new RegExp(`[:\\-—]\\s*${UUID}\\s*\\.?$`, 'i')

const SURVIVING_UUID_PATTERN = new RegExp(UUID, 'i')

const STRIPE_IDENTIFIER_PATTERN =
  /\b(cus|sub|pi|cs|acct|price|prod|in|ch|py|seti|txn|evt|re|src|card|ba|tok|whsec)_[A-Za-z0-9_]{8,}\b/

const MACHINE_TOKEN_PATTERN = /^[A-Z][A-Z0-9]*(_[A-Z0-9]+)+$/

export const SERVER_MESSAGE_MAX_LENGTH = 300

const LOW_INFORMATION_MESSAGES = new Set([
  'not found',
  'forbidden',
  'unauthorized',
  'missing authorization header',
  'invalid or expired token',
  'user account not found',
  'invalid cron secret',
  'invalid json body',
  'internal server error',
])

function isLowInformation(message: string): boolean {
  return LOW_INFORMATION_MESSAGES.has(message.toLowerCase().replace(/\.+$/, '').trim())
}

export function redactServerMessage(message: string | null | undefined): string | null {
  if (typeof message !== 'string') return null

  const trimmed = message.trim()
  if (trimmed.length === 0) return null

  const stripped = trimmed.replace(TRAILING_IDENTIFIER_PATTERN, '').trim()
  if (stripped.length === 0) return null

  if (SURVIVING_UUID_PATTERN.test(stripped)) return null
  if (STRIPE_IDENTIFIER_PATTERN.test(stripped)) return null
  if (MACHINE_TOKEN_PATTERN.test(stripped)) return null
  if (isLowInformation(stripped)) return null
  if (stripped.length > SERVER_MESSAGE_MAX_LENGTH) return null

  return stripped
}
